import { createMuiTheme } from '@material-ui/core/styles';

export const appTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: '#bed720',
      light: '#f4ff5c',
      dark: '#8aa600'
    },
    secondary: {
      main: '#4128df',
      light: '#8157ff',
      dark: '#0000ac'
    },
  },
});
